import styled from 'styled-components';
import { designTokens } from '../../ui/foundation/DesignTokens';
import { focusRing } from '../sidebarModal/SedeList.style';

// A button next to the profile button, as tall as it: both open the profile
// menu. The width is capped so a long sede name can never push the navigation
// or the profile button out: the label gives way first.
//
// From 1200px down the navigation is short of room: the badge keeps the
// compact size it always had there, and the narrower cap from 900px down.
export const Badge = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  min-width: 0;
  max-width: 180px;
  margin: 0;
  padding: 0 12px 0 5px;
  box-sizing: border-box;
  border-radius: ${designTokens.radius.full};
  border: 1px solid ${designTokens.colors.gray[200]};
  background: ${designTokens.colors.gray[100]};
  font: inherit;
  text-align: left;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    background: ${designTokens.colors.gray[200]};
  }

  ${focusRing}

  @media (max-width: 1200px) {
    gap: 6px;
    height: 32px;
    padding: 0 10px 0 4px;
  }

  @media (max-width: 900px) {
    max-width: 120px;
  }
`;

// The sede color arrives as an inline style; this gray is the neutral one.
export const BadgeMonogram = styled.span`
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${designTokens.colors.gray[600]};
  color: white;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  text-transform: uppercase;

  @media (max-width: 1200px) {
    width: 24px;
    height: 24px;
    font-size: 10px;
  }
`;

export const BadgeLabel = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${designTokens.colors.gray[700]};
  font-size: 0.9375rem;
  font-weight: 500;

  @media (max-width: 1200px) {
    font-size: ${designTokens.fontSizes.xs};
  }
`;
